import imgOne from "../images/testimonial/1.png";
import imgTwo from '../images/testimonial/2.png';
import imgThree from '../images/testimonial/3.png';

const testimonials = [
    {
        'img': imgOne,
        'name': 'Eneida Rivera',
        'description' : "Best dental experience I've had. Girls at the front desk are friendly and welcoming. The place itself is super clean. Assistant and dentist were amazing. 10 out of 10!!!",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Chris Hopper',
        'description' : 'Dr. Tran is a fantastic dentist. The whole crew is very friendly and knowledgable. 10 out of 10 would recommend!! Thank you guys!',
        'rating': 5
    },
    {
        'img': imgThree,
        'name': 'LeJoy Dickens',
        'description' : 'Today my 9 year old was having tooth pain and we were able to get a same day appointment and treatment with the dentist. Everyone was very nice and helpful and made our first time experience great. I would recommend this office to anyone needing dental care.',
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Karenn Palomo',
        'description' : 'Wonderful! I personally dont like dentists, but the staff at this place made me feel at easy !!',
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Anh Thư Phạm',
        'description' : 'The staffs are so so nice! Everything is so convenient and easy to understand. I feel comfortable because they walk me through every steps of the process.',
        'rating': 5
    },
    {
        'img': imgOne,
        'name': 'Taylor Kelley',
        'description' : 'If I could give a ten star rating I would. I’ve been so hesitant and scared to come to the dentist since it’s been so long but my mother finally convinced me to make an appointment and I’m so glad I did. The staff was amazing and made me feel so comfortable. Vanessa was so personable yet professional, I immediately felt like this was definitely a safe space and there was nothing to worry or be ashamed about. Kaylee and Hannah were also so sweet and understanding. Dr.Tran was so efficient and helpful and got straight to the point of what work I needed done. If you’re looking for a new dentistry , this is definitely the place. 10/10',
        'rating': 5
    },
    {
        'img': imgThree,
        'name': 'Lera Short',
        'description' : 'I had an amazing experience with Dr.Tran, and with his wonderful team. From the moment I walked in, the staff was incredibly welcoming, making me feel at ease right away. The office was spotless and well maintained, which gave me a sense of comfort and professionalism. Dr.Tran and his team were friendly, informative, and gentle, ensuring that the entire process was painless and smooth. I left feeling relieved and grateful for such a positive experience.',
        'rating': 5
    },
    {
        'img': imgOne,
        'name': 'Chloe Caldwell',
        'description' : "I recently had an appointment with Dr. Tran, and I couldn't be more pleased with the experience. From the moment I walked into the office, the staff was welcoming and professional. Dr. Tran was thorough in explaining my dental issues and the treatment plan, making sure I was comfortable and informed every step of the way. The office itself was clean and modern, equipped with the latest technology. My procedure was smooth and virtually pain-free, thanks to Dr. Tran's expertise and gentle approach. I highly recommend Dr. Tran to anyone looking for a skilled and compassionate dentist.",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'nolimit088',
        'description' : 'Dr. Tran and the staff and so amazing. I had a root canal done and I hardly felt anything. Dr. Tran haa a new office in Manvel. I recommend him to everybody. I am having to have some partials and he also saved my front teeth after I had thrush after using an inhale for asthma.',
        'rating': 5
    },
    {
        'img': imgThree,
        'name': 'Max N',
        'description' : "The front desk are very friendly and accommodate me alot with my appointment.This is like the only place I found that open at night. The whole process of my root canal was very quick as well. I'm very pleased with the office. Highly recommended!! :-)",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Matthew Caldwell',
        'description' : "This place is awesome, excellent care, friendly and accommodating staff which made the experience even better. If you are in need of a professional dental practice then UpDental in Manvel is where you need to be!",
        'rating': 5
    },
     {
        'img': imgTwo,
        'name': 'Mayra Martinez',
        'description' : "Up Dental is truly exceptional! From the moment you walk in, you’re greeted with friendly smiles and a clean, modern atmosphere. The staff is professional, gentle, and genuinely caring. They take the time to explain everything and make sure you’re comfortable every step of the way. Whether it’s a routine cleaning or a more complex procedure, they go above and beyond. I highly recommend Up Dental to anyone looking for quality dental care and a team that actually cares about your smile!",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Goldfisherau',
        'description' : "I had an excellent experience at Up Dental of Manvel! From the moment I walked in, the staff was warm, welcoming, and professional. My cleaning was thorough yet gentle, and the hygienist made sure I was comfortable the entire time. Dr. did a detailed check-up and explained everything clearly, which I really appreciated. The office is clean, modern, and runs right on schedule. I left feeling well cared for and confident in my dental health. Highly recommend! Close to Meridiana!",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Dan Nguyen',
        'description' : "Just had a deep cleaning and teeth extraction here. This place is spectacular and spotless!Everything is in a good condition. The staffs and Dr. Tran are beyond amazing!! They are very attentive to detail and caring, constantly making sure I was comfortable and making the process less scary and painful. Definitely recommended.",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'KRISTOPHER PEREZ',
        'description' : "I’ve had a great experience at Up Dental of Manvel! The entire team is professional, friendly, and truly cares about patient comfort. Dr. Tri Tran is knowledgeable, gentle, and takes the time to explain every step of the process, which really helped ease any anxiety I had. The office is clean, modern, and runs on time — I never had to wait long. Highly recommend to anyone looking for quality dental care!",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'R M',
        'description' : "Ladies in the front were friendly, attentive, and knowledgeable. The dental assistant was also awesome & very kind! The Dr was constantly checking that I was comfortable and not in any pain. Everyone was professional, yet down to earth also. I had a root canal and a crown done and felt 0 pain! Hubby and I have found our family dentistry! :)",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Mikey Flores',
        'description' : "I hate the dentist I have since I was a kid and this was genuinely the best experience I have had I got all 4 wisdom teeth done in one day and the procedure was swift painless and thorough. He was fast while also being excellent at his job which was really comforting because he also took all the measures to make sure I was painless and taken care of 10/10 will come back again.",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Nina Casiano',
        'description' : "Just visited this dental office for the first time, and I’m really impressed! The staff and dentist were amazing—super friendly and took the time to explain everything clearly. I really appreciate how transparent they are with treatment plan pricing—no surprises, which is a huge plus. The office itself is beautiful and well-maintained, making the experience even better. Plus, their hours are super convenient for anyone with a 9-5 schedule. Highly recommend!",
        'rating': 5
    },
     {
        'img': imgTwo,
        'name': 'Chandler Robbins',
        'description' : "Today was an amazing experience for me. My doctor, dental assistant, and front desk secretary were very helpful. I learned quite a few new things. I got to see some chickens and got my teeth cleaned.",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Kelsey Robinson',
        'description' : "Thank you for being so amazing and kind with my teeth! I totally recommend here very nice , clean and beautiful dental office treated my teeth with much care!",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Alana M',
        'description' : "I had a fantastic experience with Dr. Tran and his team. They were professional, friendly, and made me feel completely at ease. The office was clean and modern, and my procedure was quick and painless. Highly recommend!",
        'rating': 5
    },
     {
        'img': imgTwo,
        'name': 'Senorina Gonzalez',
        'description' : "My husband recently had a root canal done here, and we couldn’t be more grateful for the care he received. From the moment we walked in, the staff was warm, professional, and made him feel at ease. The front desk was welcoming and helpful with scheduling and paperwork, and the dental assistants were kind, patient, and explained everything thoroughly. \n The dentist did an amazing job on his root canal not only was the procedure done with great skill, but he also took the time to answer all of our questions and reassure my husband every step of the way. \nWe truly appreciate the entire team and providing such excellent care. I highly recommend this office to anyone looking for a dentist who genuinely cares about their patients.”",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Valencia Green',
        'description' : "We switched from another dentist and I must say the staff were very professional. Doctor Tran was very patient and made us feel very comfortable with the work he was performing. I definitely recommend this location.",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Jadyn Schupp',
        'description' : "I recently visited this dentist office for a cleaning and was blown away by the professionalism and care. The hygienist was gentle and efficient, and the dentist took the time to answer all my questions. The office is clean and modern, and the atmosphere is super calming. Five stars isn't enough – I'd give 'em ten stars if I could! ",
        'rating': 5
    },
    {
        'img': imgTwo,
        'name': 'Misty Berry',
        'description' : "They treated my son today and everyone did an excellent job from front desk check-in to the dental exam with Dr Tran. They were very informative of the treatment plan and the Dental Assistant (Jocelyn) does an amazing job 😁.The office is very clean as well. I'm very happy to recommend them to everyone 10/10",
        'rating': 5
    },
     {
        'img': imgTwo,
        'name': 'James Schupp',
        'description' : "They are a very good dental place to go to. Would recommend going there again.",
        'rating': 5
    },
     {
        'img': imgTwo,
        'name': 'Thomas Marble',
        'description' : "Awesome people. Great service very honest great integrity and very respectful this is the only dentist that I will go to and they stay open until 10 pm",
        'rating': 5
    },

]




export default testimonials